import React, { Component } from 'react';
import { Form, Icon } from 'semantic-ui-react';

import AssetGallery from '../../components/common/AssetGalleryV2/AssetGallery';
import './CanvasTile.css';

class CanvasTile extends Component {
  removeTile = (index) => {
    this.props.removeTile(index);
  };

  render() {
    return (
      <div>
        {this.props.tile ? (
          <div className="tile-container-space">
            <Form.Input
              className="input-tile"
              placeholder="Name"
              type="text"
              name="name"
              id={this.props.tileNumber}
              defaultValue={this.props.tile.name}
              value={this.props.tile.name}
              onChange={this.props.handleTileChange}
            />
            <div className="asset-gallery-container-tile">
              <AssetGallery
                getFbToken={this.props.getFbToken}
                onAssetSelected={(asset) =>
                  this.props.onSelectTile(
                    asset,
                    'videoUrl',
                    this.props.tileNumber
                  )
                }
                assetType="video"
                previewFileUrl={this.props.tile.asset}
              />
            </div>
            <a
              className="icon-trash"
              onClick={() => this.removeTile(this.props.tileNumber)}>
              <Icon size="large" name="trash alternate" />
            </a>
          </div>
        ) : null}
      </div>
    );
  }
}

export default CanvasTile;



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasTile.js